var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "avtivityheader" }, [
    _c("div", { staticClass: "activity_name" }, [
      _c("p", [_vm._v("活动名称：" + _vm._s(_vm.pcActiveName))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }